// src/pages/InvestmentAccountLedger/InvestmentAccountLedgerSlice.js
import { createSlice } from "@reduxjs/toolkit";
import {
  fetchInvestmentAccountLedger,
  fetchInvestmentAccountsBySearch,
} from "./InvestmentAccountLedgerThunk";

const initialState = {
  list: [],
  loading: false,
  investmentAccounts: [],
  investmentAccountLoading: false,
  filters: {
    accId: null,
    fromDate: null,
    toDate: null,
  },
};

const investmentAccountLedgerSlice = createSlice({
  name: "investmentAccountLedger",
  initialState,
  reducers: {
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchInvestmentAccountLedger.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchInvestmentAccountLedger.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload;
      })
      .addCase(fetchInvestmentAccountLedger.rejected, (state) => {
        state.loading = false;
      })
      .addCase(fetchInvestmentAccountsBySearch.pending, (state) => {
        state.investmentAccountLoading = true;
      })
      .addCase(fetchInvestmentAccountsBySearch.fulfilled, (state, action) => {
        state.investmentAccountLoading = false;
        state.investmentAccounts = action.payload;
      })
      .addCase(fetchInvestmentAccountsBySearch.rejected, (state) => {
        state.investmentAccountLoading = false;
        state.investmentAccounts = [];
      });
  },
});

export const { setFilters } = investmentAccountLedgerSlice.actions;
export default investmentAccountLedgerSlice.reducer;
